import { useState } from "react";
import { ParallaxScene, ParallaxLayer } from "../ParallaxScene";
import { connectionPeople } from "../../data/phase2Content";
import { useIsDesktop } from "../../hooks/useMedia";
import { ConnectionCard } from "./ConnectionCard";
import { ConnectionProposalCard } from "./ConnectionProposalCard";
import { Words } from "../Words";

const RISE = [[80, -40], [140, -80], [100, -50], [160, -100]];

export default function ConnectionsSection() {
  const desktop = useIsDesktop();
  const [flow, setFlow] = useState({ person: null, stage: "proposed" });
  const open = (p) => setFlow({ person: p, stage: p.ctaKind === "profile" ? "profile" : "proposed" });

  return (
    <ParallaxScene as="section" id="connections" offset={["start end", "end start"]} data-testid="section-connections" className="conn-stage relative overflow-hidden pb-28 pt-28 text-white lg:pb-32 lg:pt-40">
      <div className="relative mx-auto max-w-[1320px] px-5 lg:px-10">
        <div className="grid gap-6 lg:grid-cols-[1.2fr_1fr] lg:items-end">
          <div>
            <p className="eyebrow eyebrow--dark">05 · Meet people worth meeting</p>
            <h2 className="h-section mt-4" data-testid="connections-headline">
              <Words text="New People." />
              <br />
              <Words text="Real Possibilities." start={2} className="text-gradient-cool" />
            </h2>
          </div>
          <div className="lg:justify-self-end">
            <p className="max-w-[460px] text-[18px] leading-relaxed text-white/65 sm:text-[20px]">
              Discover people who share your interests, your ambitions and the experiences you want to have.
            </p>
            <p className="mt-3 text-[13px] text-white/60">Every new connection begins with a choice. · Sample content — fictional demo</p>
          </div>
        </div>
        {desktop ? (
          <div className="mt-20 grid grid-cols-2 gap-6 xl:grid-cols-4">
            {connectionPeople.map((p, i) => (
              <ParallaxLayer key={p.id} y={RISE[i]} style={{ marginTop: i % 2 ? 70 : 0 }}>
                <ConnectionCard person={p} onCta={() => open(p)} />
              </ParallaxLayer>
            ))}
          </div>
        ) : (
          <div className="no-scrollbar -mx-5 mt-12 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4" data-testid="connections-carousel">
            {connectionPeople.map((p) => (
              <div key={p.id} className="w-[78vw] max-w-[330px] shrink-0 snap-center">
                <ConnectionCard person={p} onCta={() => open(p)} />
              </div>
            ))}
          </div>
        )}
      </div>
      <ConnectionProposalCard person={flow.person} startStage={flow.stage} onClose={() => setFlow({ person: null, stage: "proposed" })} />
    </ParallaxScene>
  );
}
